import { render, staticRenderFns } from "./HeartFailure.vue?vue&type=template&id=6d832cfa&"
import script from "./HeartFailure.vue?vue&type=script&lang=js&"
export * from "./HeartFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports